// 16:9 standard
const BASE_RATIO = 1.777778;

const removeBlackBars = ({ crop, screen_ratio, aspect_ratio, original_width, original_height }) => {
  const difference = aspect_ratio / BASE_RATIO;
  let width = original_width;
  let height = original_height;
  let margin_left = 0;
  let margin_top = 0;

  if (difference > 1) {
    // Wider than the screen so we need to get rid of black bars from the top and bottom
    width = original_width * difference;
    height = width / aspect_ratio;
  } else if (difference < 1 && screen_ratio > 1) {
    // Narrower than the screen so we need to get rid of black bars from the sides, and not mobile
    height = original_height / difference;
    width = height * aspect_ratio;
  }

  if (!crop) {
    margin_left = (original_width - width) / 2;
    margin_top = (original_height - height) / 2;
  }

  return {
    width,
    height,
    margin_left,
    margin_top,
  };
};

const centerAlignment = ({ video, container_width, container_height }) => {
  if (video.width > container_width) {
    video.margin_left = (container_width - video.width) / 2;
  }

  if (video.height > container_height) {
    video.margin_top = (container_height - video.height) / 2;
  }

  return video;
};

export { removeBlackBars, centerAlignment };
